import {
  ExternalRouteRef,
  RouteRef,
  SubRouteRef,
  createExternalRouteRef,
  createRouteRef,
  createSubRouteRef,
} from '@backstage/core-plugin-api';

export enum RoutesIds {
  surfaces = 'surfaces',
  surface = 'surface',
  surfaceSettings = 'surfaceSettings',
  surfaceAvailability = 'surfaceAvailability',
}

enum ExternalRoutesIds {
  experimentationPlatformSurface = 'experimentationPlatformSurface',
}

// root route
export const surfacesRouteRef = createRouteRef({ id: RoutesIds.surfaces });

export const rootRouteRef = surfacesRouteRef;

// sub-routes within the plugin
export const surfaceRouteRef = createSubRouteRef({
  id: RoutesIds.surface,
  parent: rootRouteRef,
  path: '/:id',
});

export const surfaceSettingsRouteRef = createSubRouteRef({
  id: RoutesIds.surfaceSettings,
  parent: rootRouteRef,
  path: '/:id/settings',
});

export const surfaceAvailabilityRouteRef = createSubRouteRef({
  id: RoutesIds.surfaceAvailability,
  parent: rootRouteRef,
  path: '/:id/availability',
});

// external routes to other systems (for backward compatibility during migration)
export const experimentationPlatformSurfaceRouteRef = createExternalRouteRef({
  id: 'backstage-experimentation-platform-surface',
  params: ['id'],
  optional: true,
});

// default routes/routes to be used by other plugins
export const Routes = {
  surfaces: surfacesRouteRef,
  surface: surfaceRouteRef,
  surfaceSettings: surfaceSettingsRouteRef,
  surfaceAvailability: surfaceAvailabilityRouteRef,
} satisfies Record<RoutesIds, SubRouteRef | RouteRef>;

export const ExternalRoutes = {
  // external routes to other systems
  experimentationPlatformSurface: experimentationPlatformSurfaceRouteRef,
} satisfies Record<ExternalRoutesIds, ExternalRouteRef>;
